import React from 'react'
import { RadioGroup, Text, Flex } from 'components/ds'
import { FilterComponentProps } from 'types/filter-page'
import { useKeyPress } from 'hooks/use-key-press'

const booleanFilterOptions = [
  { value: 'true', label: 'is true' },
  { value: 'false', label: 'is false' },
]
const BooleanForm = ({
  label,
  value,
  onChange,
  operator = 'equals',
  onPress,
}: FilterComponentProps) => {
  const { handleKeyDown } = useKeyPress('Enter', onPress)

  const handleValueChange = (value: string) => {
    onChange(value, operator)
  }

  return (
    <RadioGroup.Root
      value={value}
      onValueChange={handleValueChange}
      onKeyDown={handleKeyDown}
    >
      <Flex direction="column" gap="4">
        {booleanFilterOptions.map((option, index) => (
          <RadioGroup.Item key={index} value={option.value}>
            <Text>{option.label}</Text>
          </RadioGroup.Item>
        ))}
      </Flex>
    </RadioGroup.Root>
  )
}

export default BooleanForm
